import { c as _c } from "react/compiler-runtime";
import { Button, Icon, IconSize } from '@sbt-web/ui';
import { AdReplyEvent } from '../../../events';
import classes from '../index.module.scss';
export type ContactButtonProps = {
  isSecondary?: boolean;
  showLabel?: boolean;
  showIcon?: boolean;
};
export const ContactButton = t0 => {
  const $ = _c(8);
  const {
    isSecondary: t1,
    showLabel: t2,
    showIcon
  } = t0;
  const isSecondary = t1 === undefined ? false : t1;
  const showLabel = t2 === undefined ? true : t2;
  const t3 = showLabel ? undefined : "Contatta";
  const t4 = isSecondary ? "outline" : undefined;
  let t5;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = [classes.contactButton];
    $[0] = t5;
  } else {
    t5 = $[0];
  }
  let t6;
  if ($[1] !== showIcon) {
    t6 = showIcon ? <Icon name="Mail" iconSize={IconSize.MD} /> : undefined;
    $[1] = showIcon;
    $[2] = t6;
  } else {
    t6 = $[2];
  }
  const t7 = showLabel && "Contatta";
  let t8;
  if ($[3] !== t3 || $[4] !== t4 || $[5] !== t6 || $[6] !== t7) {
    t8 = <Button aria-label={t3} design={t4} onClick={_temp} classes={t5} icon={t6} size="large">{t7}</Button>;
    $[3] = t3;
    $[4] = t4;
    $[5] = t6;
    $[6] = t7;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  return t8;
};
function _temp() {
  window.dispatchEvent(new CustomEvent(AdReplyEvent.ContactButtonClick));
}